// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Vuex from 'vuex'
import store from './config/store'
//懒加载
import VueLazyload from 'vue-lazyload'
//路径
import url from '@/config/url'
//头部
import headGuide from '@/components/header/headGuide';
Vue.component("head-guide", headGuide);
//尾部
import footGuide from "@/components/footer/footGuide";
Vue.component("foot-guide", footGuide);
import {
  imgClipping
} from '@/plugins/mixin'
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(Vuex)
Vue.use(VueLazyload, {
  error:'./static/error.jpg',
  loading:'./static/loading.jpg'
})

//页面返回不刷新
// const history = window.sessionStorage
// history.clear()
// let historyCount = history.getItem('count') * 1 || 0
// history.setItem('/', 0)
// router.beforeEach(function(to, from, next) {
//    const toIndex = history.getItem(to.path);
//    const fromIndex = history.getItem(from.path);
//根据路由判断操作是前进还是后退，并把标记值存入vuex
//    if(toIndex) {
//       if(!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
//          store.commit('UPDATE_DIRECTION', 'forward')
//       } else {
//          store.commit('UPDATE_DIRECTION', 'reverse')
//          history.removeItem(from.path)
//       }
//    } else {
//       ++historyCount
//       history.setItem('count', historyCount)
//       to.path !== '/' && history.setItem(to.path, historyCount)
//       store.commit('UPDATE_DIRECTION', 'forward')
//    }
//    if(/\/http/.test(to.path)) {
//       let url = to.path.split('http')[1]
//       window.location.href = `http${url}`
//    } else {
//       next()
//    }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  url,
  components: { App },
  template: '<App/>'
})
Vue.mixin(imgClipping);



// WEBPACK FOOTER //
// ./src/main.js